import React from 'react';

import ForgotPasswordForm from '@/components/forgotPassword/ForgotPasswordForm';

const ForgotPassword = () => {
  return (
    <div className="h-[calc(100vh-120px)] flex items-center justify-center">
      <ForgotPasswordForm />
    </div>
  );
};

export default ForgotPassword;
